import O1HD from "../../engines/gameEngine";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../modes/normalMode/BundleResourceConfig";
import NormalGameManager from "../../modes/normalMode/manager/NormalGameManager";
import { getpawnShopObjMap, pawnShopObjQualityColorStrAry, pawnShopObjQualityExplainAry } from "../pawnShopGame/pawnShop/config/pawnShopConfig";
import { pawnShopFixGameSelectDataI } from "../pawnShopGame/pawnShop/const/pawnShopConst";
import pawnShopFixGameSelectPage from "./pawnShopFixGameSelectPage";

const {ccclass, property} = cc._decorator;

@ccclass
export default class pawnShopFixGameResult extends cc.Component {

    @property({type:cc.Sprite,tooltip:"展示的图片"})
    showSp:cc.Sprite = null;

    @property({type:cc.RichText,displayName:"修复文本"})
    lbFix:cc.RichText = null;

    @property({type:cc.RichText,displayName:"名字文本"})
    lbName:cc.RichText = null;

    @property({type:cc.Node,displayName:"继续修复按钮"})
    btnContinue:cc.Node = null;

    @property({type:cc.Node,displayName:"光效节点"})
    lightNode:cc.Node = null;

    data:pawnShopFixGameSelectDataI = null;

    page:pawnShopFixGameSelectPage = null;

    onLoad(){
        let tween = cc.tween(this.lightNode).to(4,{angle:360}).call(()=>{
            this.lightNode.angle = 0;
        });
        cc.tween(this.lightNode).repeatForever(tween).start();
    }

    bindData(data:pawnShopFixGameSelectDataI,page:pawnShopFixGameSelectPage){
        this.page = page;
        this.data = data;
        this.loadDialog();
    }

    loadDialog(){
        this.lbFix.string = `<color = #FFFFFF>已修复</c><color = #04FD37>${this.data.obj.fixCount}</c><color = #FFFFFF>/${this.data.obj.canFixCount}</c>`;
        let pawnConfig = getpawnShopObjMap()[this.data.obj.id];
        let name = pawnConfig.name;
        this.lbName.string = `<color = #FFFFFF>${name}(</c><color = #${pawnShopObjQualityColorStrAry[pawnConfig.quality]}>${pawnShopObjQualityExplainAry[pawnConfig.quality]}</c><color = #FFFFFF>)</c>`;
        if(this.data.obj.fixCount >= this.data.obj.canFixCount){
            this.btnContinue.active = false;
        }
        getOneBundleByInstant(BUNDLE_SMALL_NAME.pawnShopGameBundle).load(`assets/pawnShopGame/obj/${name}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.error(err,"pawnShopGameFixResult.ts 32 loadDialog fail");
                return;
            }
            this.showSp.spriteFrame = spr;
        });
    }

    closeThis(){
        this.page.reLoadItems();
        this.node.destroy();
        this.node.removeFromParent();
    }

    canClick:boolean = true;

    async onBtnContinue(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if(!this.canClick) return;
        this.canClick = false;
        let isTrue = await this.page.onFix();
        if(isTrue){
            this.closeThis();
        }else{
            this.canClick = true;
        }
    }

    onBtnSell(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let objConfig = getpawnShopObjMap()[this.data.obj.id];
        let price = objConfig.price;
        let fixMultiple = this.data.obj.fixCount * 1.5;
        let multiple = fixMultiple > 0 ?fixMultiple : 1;
        price *= multiple;
        O1HD.getServices().userSrv.setCoins(price,true,this.node);
        NormalGameManager._instance.pawnShopManager.removeOneObj(this.data.obj.id,this.data.index);
        this.closeThis();
    }

    onBtnClose(){
        this.closeThis();
    }
    
}
